import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import { heritageColors } from '../../../../heritageTheme.ts';

/**
 * Table – תבנית טבלה אופקית עם שורות מסודרות
 * מתאימה למידות רחבות, מציגה כל איש קשר בשורה עם עמודות: תפקיד, שם, טלפון
 */
const Table = ({ initialData = { contacts: [] }, title = 'אנשי קשר והנהלה', showTitle = true }) => {
  const contacts = initialData.contacts || [];

  return (
    <div style={{
      padding: '1em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          borderBottom: `0.0625em solid ${heritageColors.gold}`,
          paddingBottom: '0.625em',
          marginBottom: '0.75em',
        }}>
          <GroupsIcon sx={{ color: heritageColors.navy, fontSize: '1.25em' }} />
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.navy,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {contacts.length === 0 ? (
        <div style={{ color: heritageColors.slate, fontSize: '0.875em', textAlign: 'center' }}>
          אין אנשי קשר להצגה
        </div>
      ) : (
        <div style={{ flex: 1, overflow: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.8125em',
          }}>
            <thead>
              <tr style={{
                backgroundColor: heritageColors.navy,
                color: '#fff',
              }}>
                <th style={{ padding: '0.5em 0.75em', textAlign: 'right', fontWeight: 600 }}>תפקיד</th>
                <th style={{ padding: '0.5em 0.75em', textAlign: 'right', fontWeight: 600 }}>שם</th>
                <th style={{ padding: '0.5em 0.75em', textAlign: 'right', fontWeight: 600 }}>טלפון</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact, index) => (
                <tr
                  key={contact.id || index}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fff' : heritageColors.cream,
                    borderBottom: `0.03125em solid ${heritageColors.borderLight}`,
                  }}
                >
                  <td style={{
                    padding: '0.5em 0.75em',
                    color: heritageColors.teal,
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                  }}>
                    {contact.role}
                  </td>
                  <td style={{
                    padding: '0.5em 0.75em',
                    color: heritageColors.navy,
                    fontWeight: 'bold',
                  }}>
                    {contact.name}
                  </td>
                  <td style={{
                    padding: '0.5em 0.75em',
                    color: heritageColors.slate,
                    letterSpacing: '0.03125em',
                    direction: 'ltr',
                    textAlign: 'right',
                  }}>
                    {contact.phone || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Table;
